import { memo } from 'react';
import BaseIcon from './BaseIcon';
import type { IconProps } from './types';

const CheckmarkIcon = (props: IconProps) => {
    return (
        <BaseIcon viewBox="0 0 11.694 8.589" {...props} fill="none">
            <path
                fill="none"
                stroke="currentColor"
                strokeWidth="2px"
                d="M-5024.82,579.91l3.812,3.812,6.468-6.468"
                transform="translate(5025.527 -576.547)"
            />
        </BaseIcon>
    );
};
export default memo(CheckmarkIcon);
